module.exports = "tr {\r\n\tcursor: pointer; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/assays/assay-list/assay-list.component.css
// module id = ./src/app/assays/assay-list/assay-list.component.css
// module chunks = main